// @flow
import NodeCheckBox from "./NodeCheckBox";
import "./NodeCheckBox.scss";
import { deepClone, stringToObject } from "./../../../../../utils/helpers";

type Props = {
    choices?: Array,
    onChange: Function,
};

export default function NodeCheckBoxContainer({
    choices,
    onChange,
}: Props): React$Element<any> {
    let currentChoices = deepClone(choices); // getting reassigned

    const onCheck = (id: string, selectedChoice: any) => {
        const selected = !selectedChoice.selected; // as its get altered -> boolean

        currentChoices = currentChoices.map((choice) => {
            if (choice?.id === selectedChoice?.id) {
                // for currently clicked element
                if (selected) {
                    choice.selected = true;
                } else {
                    choice.selected = false;
                    choice.value = null;
                    if (choice.nodes)
                        choice.nodes = setAllChildrenToFalse(choice.nodes);
                }
            } else {
                // for all other
                if (selectedChoice?.metadata?.clear_other === "true") {
                    if (selected) {
                        choice.selected = false;
                        if (choice.nodes)
                            choice.nodes = setAllChildrenToFalse(choice.nodes);
                    }
                } else {
                    if (choice?.metadata?.clear_other === "true") {
                        choice.selected = false;
                        choice.value = null;
                    }
                }
            }

            return choice;
        });

        onChange(null, currentChoices);
    };

    const onOtherValueChange = async (
        value: string,
        nodeId: string,
        choice: any
    ) => {
        await findAndUpdateNode(choice.nodes, nodeId, value, 1, true);
        onChange(null, updateAllChoices(choice));
    };

    const onNodeCheck = async (
        nodeChecked: boolean,
        nodeId: string,
        choice: any
    ) => {
        await findAndUpdateNode(choice.nodes, nodeId, nodeChecked, 1, false); // wait till traverse through all the nodes
        onChange(null, updateAllChoices(choice));
    };

    const onCheckboxValueChange = (value: any, choice: any) => {
        choice.value = value;
        onChange(null, updateAllChoices(choice));
    };

    const findAndUpdateNode = async (
        choices: any,
        nodeId: string,
        nodeChecked: Boolean,
        index: number = 1,
        otherValue
    ) => {
        let lnodes = choices.filter(
            (choice) => choice.id === nodeId.split("-")[index]
        );

        if (index === nodeId.split("-").length - 1) {
            if (!otherValue) lnodes[0].selected = !lnodes[0].selected;

            const metadata = stringToObject(lnodes[0].metadata);

            if (lnodes[0].selected) {
                metadata?.has_other === "true"
                    ? (lnodes[0].value =
                          typeof nodeChecked === "boolean" ? "" : nodeChecked)
                    : (lnodes[0].value = null);
            } else {
                if (lnodes[0].nodes && metadata?.has_other !== "true") {
                    lnodes[0].nodes = setAllChildrenToFalse(lnodes[0].nodes);
                }

                lnodes[0].value = null;
            }

            return {};
        } else {
            lnodes = lnodes[0].nodes;
            findAndUpdateNode(
                lnodes,
                nodeId,
                nodeChecked,
                index + 1,
                otherValue
            );
        }
    };

    const setAllChildrenToFalse = (nodes: array) => {
        return (
            nodes &&
            nodes.map((node: Array) => {
                node.selected = false;
                node.value = null;
                node.nodes = node.nodes && setAllChildrenToFalse(node.nodes);

                return node;
            })
        );
    };

    const updateAllChoices = (choice: any) => {
        currentChoices = currentChoices.map((c) => {
            if (choice?.id === c?.id) {
                c.selected = choice.selected;
                if (choice.value) c.value = choice.value;
            }

            return c;
        });

        return currentChoices;
    };

    return (
        <div className="checkbox-container">
            <div className="row">
                {currentChoices &&
                    currentChoices.map((choice) => (
                        <div className="col-md-6">
                            <NodeCheckBox
                                key={choice.id}
                                id={choice.id}
                                selected={choice.selected || false}
                                title={choice.title}
                                inputValue={choice.value}
                                nodes={choice.nodes || []}
                                hasOther={choice.metadata?.has_other || false}
                                onChange={(value: any) => {
                                    onCheckboxValueChange(value, choice);
                                }}
                                onCheck={() => onCheck(choice.id, choice)}
                                onOtherValueChange={(
                                    value: string,
                                    nodeId: string
                                ) => {
                                    onOtherValueChange(value, nodeId, choice);
                                }}
                                onNodeCheck={(
                                    checked: boolean,
                                    nodeId: string
                                ) => onNodeCheck(checked, nodeId, choice)}
                            />
                        </div>
                    ))}
            </div>
        </div>
    );
}
